// CSS
import '_Asset/css/User/Page/design.css'
import '_Asset/css/User/Page/UiComponent/button.css'
import { apiHost } from '_Route/Api'
import { fileDownload } from 'Admin/Component/AdFunc'

// Button Components
const BtnList = ({item}) => {
  return (
    <div className="contInfo">
      <button type="button" className={`btn ${item.size} ${item.round ? item.round : ''} ${item.color} ${item.icoPos ? item.icoPos : ''} ${item.txtPos ? item.txtPos : ''}`}>
        {item.icoPos === 'left' ? <i className={item.icoName}></i> : ''}
        {item.class === 'i_only' ? <i className={item.icoName}></i> : item.class}
        {item.icoPos === 'right' ? <i className={item.icoName}></i> : ''}
      </button>

      <h2>{item.info}</h2>
    </div>
  )
}

const btnArr = [
  {
    name: 'Button Size',
    class: 'Class: [input / xl, lg, md, sm, xs]',
    btnList: [
      {size: 'xl', round: 'round_10', color: 'sfrtBlue', class: 'xl', info: 'height 50px'},
      {size: 'lg', round: 'round_10', color: 'sfrtBlue', class: 'lg', info: 'height 45px'},
      {size: 'md', round: 'round_10', color: 'sfrtBlue', class: 'md', info: 'height 40px'},
      {size: 'sm', round: 'round_10', color: 'sfrtBlue', class: 'sm', info: 'height 35px'},
      {size: 'xs', round: 'round_10', color: 'sfrtBlue', class: 'xs', info: 'height 30px'},
    ]
  },
  {
    name: 'Button Round',
    class: 'Class: [input / round_10, round_100]',
    btnList: [
      {size: 'md', round: '', color: 'sfrtBlue', class: 'round X', info: 'Round X (Basic)'},
      {size: 'md', round: 'round_10', color: 'sfrtBlue', class: 'round_10', info: 'round 10px'},
      {size: 'md', round: 'round_100', color: 'blue_edge', class: 'round_100', info: 'round 40px'},
    ]
  },
  {
    name: 'Icon Button',
    class: 'Class: [input / between, i_only]',
    btnList: [
      {size: 'md', round: 'round_10', color: 'black', icoPos: 'left', icoName: 'icofont-search', class: 'between', info: 'Icon left'},
      {size: 'md', round: 'round_10', color: 'black_edge', icoPos: 'right', icoName: 'icofont-search', class: 'between', info: 'Icon right'},
      {size: 'md', round: 'round_10', color: 'black_edge', icoPos: 'i_only', icoName: 'icofont-check-circled', class: 'i_only', info: 'Icon only'},
    ]
  },
  {
    name: 'Text Position',
    class: 'Class: [input / lt, rt]',
    btnList: [
      {size: 'md', round: 'round_10', color: 'black', txtPos: 'lt', class: 'lt', info: 'Text left'},
      {size: 'md', round: 'round_10', color: 'black_edge', txtPos: '', class: 'X', info: 'Text center (Basic)'},
      {size: 'md', round: 'round_10', color: 'black_edge', txtPos: 'rt', class: 'rt', info: 'Text right'},
    ]
  },
]

const Button = () => {
  return (
    <div className="componentBox">
      <div className="pageTit">
        <h2>Buttons <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
      </div> 

      <div className="useWay">
        <h2>How to use the button kit</h2>
				<p>Click button to copy and paste where you want to use it.</p>
        <p>Bagic Class: <span>btn</span></p>
        <p>Ex. class="<span>btn sm gray_100 round_10 i_lt</span>"</p>
      </div>

      {btnArr.map((key, i) => 
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>버튼을 눌러 태그를 복사 할 수 있습니다.</p>
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap">
            {key.btnList.map((item, i) => 
              <BtnList key={i} item={item} />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Button